<div id="main-nav" class="nav-container">
  <mat-toolbar color="primary">
    <ng-content select="[nav-toggle]"></ng-content>
    <span routerLink="/" class="navigation-heading">Magaliesberg Pharmaceuticals</span>
    <span class="spacer"></span>
    <ng-content select="[sign-in]"></ng-content>
    <ng-content select="[account]"></ng-content>
  </mat-toolbar>
  <mat-progress-bar class="progress-bar" *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</div>